import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  cursor: pointer;
`;

const Bar = styled.div`
  width: 100%;
  height: 0.3rem;
  background-color: ${p => p.theme.textColor};
  opacity: ${p => p.isClosed ? 0.7 : 0.8};
  margin: 0.4rem 0;
  transition: all 0.35s ease;
`;

export const Top = Bar.extend`
  transform: ${p => p.isClosed ? 'translateY(0.7rem) translateX(0) rotate(45deg)' : 'none'};
`;

export const Middle = Bar.extend`
  opacity: ${p => p.isClosed ? 0 : 0.8};
`;

export const Bottom = Bar.extend`
  transform: ${p => p.isClosed ? 'translateY(-0.7rem) translateX(0) rotate(-45deg)' : 'none'};
`;



// WEBPACK FOOTER //
// ./components/Hamburger/Hamburger.style.js